<template>
    <div class="login-page">
        <div class="login-container-background"></div>
        <div class="login-container">
            <el-dialog title="修改密码" :visible.sync="modifyPwdVisible"  width="600px" :show-close="false">
                <p style="color: #fd5353; text-align: center; margin-bottom: 20px;">{{modifyPwdTip}}</p>
                <el-form ref="modifyPwdForm" :model="modifyPwdForm" :rules="pwdRules" label-width="100px">
                    <el-form-item label="原密码：">
                        <el-input v-model.trim="modifyPwdForm.oldPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                    </el-form-item>
                    <el-form-item label="新密码：" prop="newPwd">
                        <el-input v-model.trim="modifyPwdForm.newPwd" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码：" prop="newPwdAgain">
                        <el-input v-model.trim="modifyPwdForm.newPwdAgain" show-password clearable @keyup.native.enter="modifyPwd()"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="cancel">取 消</el-button>
                    <el-button type="primary" @click="modifyPwd">确 定</el-button>
                </div>
            </el-dialog>
        </div>

        <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form">
            <div>
                <h1>玖玖通信后台管理系统</h1>
            </div>
            <el-form-item class="form-item" prop="accountName" >
                <el-input v-model.trim="loginForm.accountName" placeholder="请输入帐号" prefix-icon="el-icon-user" size="large" class="userName"> </el-input>
                <div class="showRememberAccount" v-if="showAccountsPanel">
                    <RememberAccount @func="getAccountFormSon" ></RememberAccount>
                </div>
            </el-form-item>

            <el-form-item class="form-item" prop="pwd">
                <el-input v-model.trim="loginForm.pwd" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password size="large" class="userName"  @keyup.native.enter="handleLogin"></el-input>
            </el-form-item>

            <el-checkbox v-model="rememberMe" style="color:black" >记住密码</el-checkbox>
            <el-form-item  class="form-item">
                <el-button type="primary" class="login-btn" @click.prevent = "handleLogin" size="large">登录</el-button>
            </el-form-item>
              <!-- <el-link target="_blank" style="color:#3B3A54;" :underline="false">微信公众号链接</el-link> -->
        </el-form>
    </div>
    
</template>
<script>
import {login} from '@/api/user.js'
import {sysRequest} from '@/api/customizedRequest.js'
import { mapActions } from "vuex";
import RememberAccount from '@/component/RememberAccount'
export default {
    components: {RememberAccount },
    name: 'login',
    data(){
        var checkNewPwd = (rule, value, callback) => {
            if(value.length > 16 || value.length < 6){
                return callback(new Error('请输入6 ~ 16位密码'))
            }
            callback();
        };
        var checkPwd = (rule, value, callback) => {
            if(value != this.modifyPwdForm.newPwd){
                return callback(new Error('两次输入密码不一致'))
            }
            callback();
        };
        return {
            loginForm: {
                accountName: '',
                pwd: ''
            },
            loginRules: {
                accountName: [
                    {required: true, message: '请输入用户名', trigger: 'blur'}
                ],
                pwd: [
                    {required: true, message: '请输入密码', trigger: 'blur'}
                ]
            },

            rememberMe:false,

            //修改密码
            modifyPwdVisible:false,
            modifyPwdTip:'',
            modifyPwdForm: {
                id: '',
                oldPwd: '',
                newPwd: '',
                newPwdAgain: ''
            },
            pwdRules: {
                newPwd: [
                    {validator: checkNewPwd, trigger: 'blur'}
                ],
                newPwdAgain: [
                    {validator: checkPwd, trigger: 'blur'}
                ]
            },

            qrCodeUrl:window.location+'assets/alipay.png',
        }
    },
    methods: {
        ...mapActions("menu", {
            setNickName: "setNickName",
            setBtns:"setBtns"
        }),
        getAccountFormSon(data){
            if(data.account.length > 0){
                this.loginForm.accountName = data.account;
                this.loginForm.pwd = data.password;
            }
        },
        handleLogin(){
            this.$refs.loginForm.validate(valid => {
                if(valid){       
                    login(this.loginForm).then(res => {                     
                        if(res.data.code == 200){
                            localStorage.setItem('token', res.data.data.token);
                            localStorage.setItem('id', res.data.data.id);
                            localStorage.setItem('agentId', res.data.data.agentId);
                            this.$store.commit('menu/setToken', res.data.data.token);
                            this.$store.commit('menu/setId', res.data.data.id);
                            var nickName = res.data.data.nickName;
                            this.setNickName(nickName);
                            this.setBtns(res.data.data.actionCodes);
                            this.$router.push('AdminHome');

                            if(this.rememberMe){
                                this.setAutoCompleteData("loginAccounts", this.loginForm.accountName+'/'+this.loginForm.pwd, 8);
                            }

                        }else if(res.data.code == 410){
                            let token = res.data.data.token;
                            let id = res.data.data.id;
                            localStorage.setItem('token', token);
                            this.modifyPwdForm.id = id;
                            this.modifyPwdTip = res.data.message;
                            this.modifyPwdVisible = true;
                        }
                        else if(res.data.code == 400){
                            this.$message.error(res.data.message)
                        }
                    })
                }else{
                    return;
                }
            })
        },

        //修改密码
        modifyPwd(){
            this.$refs.modifyPwdForm.validate(valid => {
                if(valid) {
                    sysRequest('sysUser/updatePwd', this.modifyPwdForm, 'post').then(res => {
                        var code = res.data.code;
                        if(code == 200){
                            let s = '<span style="color: #fd5353;">'+"为保证账户安全，请不要轻易泄露自己的账户及密码。"+'</span>'
                            this.$alert('修改密码成功！请使用新密码重新登录。'+s, '提示', 
                                { confirmButtonText: '确定', 
                                dangerouslyUseHTMLString: true, 
                                callback: action => {
                                    window.location.href = window.location;
                                }
                            });
                        }
                        else{
                            this.$message.error(res.data.message);
                        }
                    });
                                               
                }
            })
        },

        cancel(){
            for(var key in this.modifyPwdForm){
                this.modifyPwdForm[key] = '';
            }
            this.$refs['modifyPwdForm'].resetFields();
            this.modifyPwdVisible = false;
        },
    },

    computed: {
        showAccountsPanel: function () {
            let account = this.getAutoCompleteData('loginAccounts');
            if(account!=null && account!=undefined && account.length > 0){
                if(this.loginForm.accountName.length > 0){
                    return false;
                }else{
                    return true;
                }
            }else{
                return false;
            }
        }
    },

    created(){
        
    },

    mounted () {


    }
}
</script>

<style lang="less" scoped>
    .login-page{
        position: relative;
        height: 100%;
        overflow: hidden;
        .login-container-background {
            height: 100%;
            background: url('./../../assets/login12.png') no-repeat;
            background-size: cover;
            animation: myScale 60s;
        }

        .login-container {
            height: 100%;
        }

        // @keyframes myScale 动态
        // {
        //     0% {transform: scale(1);}
        //     100% {transform: scale(1.5);}
        // }

        .login-form {
            position: absolute;
            top: 40%;
            left: 50%;
            width: 300px;
            height: 360px;
            margin: -180px 0 0 -200px;
            padding: 50px 50px 0 50px;
            background: #fff;
            border-radius: 30px;
            .userName{
                /deep/ .el-input__inner{
                    padding-left:40px;
                    border:none;
                    border-bottom:1px solid #DCDFE6;
                    border-radius:0;
                }
                /deep/.el-input__icon{
                    font-size:20px;
                    color:#2BAEC3;
                }
            }
            h1 {
                text-align: center;
                color: #128bf1;
                font-size: 26px;
                margin-bottom: 20px;
            }

            .login-btn {
                width: 100%;
                margin-top: 15px;
                background: #2BAEC3;
                border-color: #2BAEC3;
            }
            .link {
                float: right;
                margin: 10px -26px 0 0;
            }
        }

        .showRememberAccount{
            position: absolute;
            box-sizing: border-box;
            width: 100%;
            background: #f7f7f7;
            border: 1px solid #dcdfe6;
            border-radius: 5px;
            z-index: 9;
        }

        .qrcode-show{
            width: 300px;
            a{
                font-size: 14px;
            }

            a:last-child{
                margin-left: 132px;
            }

        }

    }
.el-button--primary {
    color: #FFF;
    background-color: #0c64eb;
    border-color: #409EFF;
}
    
.login-form h1[data-v-a49090ce] {
    text-align: center;
    color: #2BAEC3;
    font-size: 30px;
    margin-bottom: 18px;
}


</style>